import React, { forwardRef, ForwardRefRenderFunction, useEffect, useMemo } from 'react';
import {
  EnglishPdfProp,
  EnglishPdfRef,
} from '@/pages/specialPriceTable/searchSpecialPriceList/components/driverCarriesSpecialRateMeterPdf/previewSpecialsPdf/type';
import { BaseTextFieldSize, MarginTop } from '@/styles';
import {
  Box,
  Grid,
  List,
  ListItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import RoundedTransparentBox from '../engine/RoundedTransparentBox';
import image from '@/pages/specialPriceTable/searchSpecialPriceList/images/specialPrice.png';
import PdfA4Tool from '@/components/pdfTool/pdfA4ToolIndex';
import globalI18n from '../previewSpecialsMailPdf/previewSpecialsMailPdf-i18n';
import { I18nextProvider, useTranslation } from 'react-i18next';

/**
 * 司机带Pdf预览查看111
 * @param props
 * @param ref
 * @constructor
 */
const Pdf:
    ForwardRefRenderFunction<EnglishPdfRef, EnglishPdfProp> = (props, ref) => {
      const { PriceDto } = props;

      // 1. 克隆
      const localI18n = useMemo(() => globalI18n.cloneInstance(), []);

      useEffect(() => {
        localI18n.changeLanguage(PriceDto.Language);
      }, [PriceDto.Language]);

      return (
          <I18nextProvider i18n={localI18n}>
              {/* 这里用一个函数当子组件的方式： */}
              <PdfContent {...props} />
          </I18nextProvider>
      );
    };

export default forwardRef(Pdf);

function PdfContent(props:EnglishPdfProp) {
  const { PriceDto, PdfPaperId, ClassName } = props;
  const { t } = useTranslation();
  return (
      //
      <PdfA4Tool className={ClassName} PdfPaperId={PdfPaperId} image={image}>

          <Grid spacing={1} container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Grid item xs={12}>
                  <Typography variant="h5" gutterBottom align={'center'} sx={{ color: 'red' }}>
                  S.J. Distributors LLC.
                  </Typography>
                  { <Typography variant="h6" gutterBottom align={'center'}>
                      Sales Agent TEL : {PriceDto.SalesPhone} ( {PriceDto.SalesName} )
                  </Typography>
                 /* <Typography variant="subtitle1" gutterBottom align={'center'} sx={{ color: 'red' }}>
                      {t('SalesHorarioDeTrabajo')} :{PriceDto.SalesOfficeHours}
                  </Typography>
                  <Typography variant="subtitle1" gutterBottom align={'center'} sx={{ color: 'red' }}>
                      {t('CallDetails')}
                  </Typography> */}
              </Grid>
          </Grid>
          <Grid spacing={1} container>
              <Grid item xs={2}>
                  <List>
                      <ListItem>
                          <Box>
                              <Typography variant={'subtitle2'} textAlign={'center'}>
                                  <RoundedTransparentBox width={400} sx={{
                                    transform: 'rotate(-90deg) translate(-100px, -160px)',
                                  }}>
                                      <Box>
                                          © Copyright 2011 by S.J. Distributors LLC. All rights reserved .
                                      </Box>
                                      <Box>
                                          Prices are subject to valued customer only .
                                      </Box>
                                  </RoundedTransparentBox>
                              </Typography>
                          </Box>
                      </ListItem>
                  </List>
              </Grid>
              <Grid item xs={8}>
                  <TableContainer sx={MarginTop} component={Paper}>
                      <Table aria-label="CustomerTable"
                             size={BaseTextFieldSize}>
                          <TableBody>
                              {PriceDto.List1.map((row, index) => (
                                  <TableRow
                                      key={row.MaterialNumber.length > 0 ? row.MaterialNumber : index + 'list1'}>
                                      <TableCell align={'left'} width={350}>
                                          {row.MaterialDescribe}
                                      </TableCell>
                                      <TableCell>
                                          ..........................
                                      </TableCell>
                                      <TableCell align={'right'}>
                                          ${row.Price}
                                      </TableCell>
                                  </TableRow>
                              ))}
                          </TableBody>
                      </Table>
                  </TableContainer>
              </Grid>
              <Grid item xs={2}>
                  <List>
                      <ListItem>
                          <Typography variant={'h5'} sx={{ color: 'red' }}>
                              Weekly
                              Price list
                          </Typography>
                      </ListItem>
                      <ListItem>
                          <Box height={'132px'}>
                              &nbsp;
                          </Box>
                      </ListItem>
                  </List>
              </Grid>
          </Grid>

          <Grid spacing={1} container>
              <Grid item xs={2}>
              </Grid>
              <Grid item xs={8}>
                  <Box sx={{
                    height: 200,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    color: 'red',
                  }}>
                      <Typography variant={'h5'} textAlign={'center'}>
                          {PriceDto.RestaurantName} ({PriceDto.PersonReceivingTheDocument})<br/>
                          {PriceDto.HouseNumber}<br/>
                          {PriceDto.City}, {PriceDto.Province}, {PriceDto.PostCode}
                      </Typography>
                  </Box>
              </Grid>
              <Grid item xs={2}>
                  <Box sx={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Typography variant={'h4'} textAlign={'center'}>
                          {PriceDto.WhetherToSubmitDate !== 'NO' && PriceDto.OfferDateRange && !PriceDto.OfferDateRange.includes('0001') ? PriceDto.OfferDateRange : ''}
                      </Typography>
                  </Box>
              </Grid>
          </Grid>

          <Grid spacing={1} container>
              <Grid item xs={2}>
              </Grid>
              <Grid item xs={8}>
                  <TableContainer sx={MarginTop} component={Paper}>
                      <Table aria-label="CustomerTable"
                             size={BaseTextFieldSize}>
                          <TableBody>
                              {PriceDto.List2.map((row, index) => (
                                  <TableRow
                                      key={row.MaterialNumber.length > 0 ? row.MaterialNumber : index + 'list2'}>
                                      <TableCell align={'left'} width={350}>
                                          {row.MaterialDescribe}
                                      </TableCell>
                                      <TableCell>
                                          ..........................
                                      </TableCell>
                                      <TableCell align={'right'}>
                                          ${row.Price}
                                      </TableCell>
                                  </TableRow>
                              ))}
                          </TableBody>
                      </Table>
                  </TableContainer>
              </Grid>
              <Grid item xs={2}>
              </Grid>
          </Grid>
          <Grid spacing={1} container>
              <Grid item xs={2}></Grid>
              <Grid item xs={8}>
                  <Typography variant="body1" gutterBottom align={'center'} sx={{ color: 'red' }}>
                      {t('LearnMoreProductInfo')}
                  </Typography>
              </Grid>
              <Grid item xs={2}></Grid>
          </Grid>

          {/* <Box */}
          {/*    sx={{ */}
          {/*      position: 'absolute', */}
          {/*      top: '1080px', // 距离顶部50px */}
          {/*      left: '600px', // 距离左侧50px */}
          {/*      width: '100px', */}
          {/*      height: '35px', */}
          {/*    }} */}
          {/* > */}
          {/*    {PriceDto.RightBottomLabel} */}
          {/* </Box> */}
      </PdfA4Tool>
  );
}
